/**
 * Validates if the given value is an array containing only valid items.
 *
 * @param value - The value to validate.
 * @param isValidItem - A function that checks if an item is valid.
 * @returns A boolean indicating whether the value is a valid array.
 */
export function validateArray<T>(value: unknown, isValidItem: (item: T) => boolean): boolean {
    if (!Array.isArray(value)) {
        return false;
    }
    return value.every(isValidItem);
}
